import React from "react";
import { useLocalization } from "../../context/LocalizationContext";
import Header from "../../containers/Header";
import InstructionCard from "../../components/shared/InstructionCard";
import mobileLogoIcon from "../../assets/icons/newDesign/mobileLogo.svg";
import "./styles.css";

const Instructions: React.FC = () => {
  const { t } = useLocalization();
  const phoneAlt = t("instructions.phone");

  return (
    <div className="instructions-container page-container scrollable-page">
      <Header
        showBackButton="LEFT"
        showSettingsButton
      />

      <div className="instructions-content">
        <InstructionCard
          size="large"
          title={t("instructions.step1Title")}
          descriptions={[t("instructions.step1Description")]}
          note={t("instructions.step1Note")}
          iconSrc={mobileLogoIcon}
          showStoreBadges
          alt={phoneAlt}
        />

        <div className="instructions-row">
          <InstructionCard
            size="medium"
            layout="horizontal"
            title={t("instructions.step2Title")}
            descriptions={[
              t("instructions.step2Description1"),
              t("instructions.step2Description2"),
            ]}
            alt={phoneAlt}
          />
          <InstructionCard
            size="medium"
            title={t("instructions.step3Title")}
            descriptions={[t("instructions.step3Description")]}
            alt={phoneAlt}
          />
        </div>

        <InstructionCard
          size="large"
          title={t("instructions.step4Title")}
          descriptions={[t("instructions.step4Description")]}
          note={t("instructions.step4Note")}
          showStoreBadges
          alt={phoneAlt}
        />
      </div>
    </div>
  );
};

export default Instructions;
